import { DrainagePlanService } from "@/app/plans/drainage/services/drainage.plan.service"


const initPlanData = {
  type: 'drainage',
  name: null,
  device_id: null,

  camp_leave: null,
  camp_back: null,
  work_areas: [],
}


const initialState = () => {
  return {
    loading: false,
    errors: {},
    data: Object.assign({}, initPlanData)
  }
}


const state = initialState()

const mutations = {

  RESET_STORE_DATA(state) {
    Object.assign(state, { ...initialState() })
  },

  REQUEST_SEND(state) {

    Object.assign(state, {
      loading: true,
      errors: {}
    })
  },

  REQUEST_FINISHED(state) {
    Object.assign(state, {
      loading: false,
    })
  },


  SET_PLAN_DATA(state, data) {

    Object.assign(state.data, {
      ...data,
      work_areas: data.data.work_areas

    })

    delete state.data.data

  },

  RESET_REPEATER_FORM(state) {
    Object.assign(state.data, {

      irrigation: [],
      tanks: []
    })
  },

  REQUEST_SUCCESS(state) {
    Object.assign(state, {
      data: Object.assign({}, initPlanData),
      errors: {},
      loading: false
    })
  },

  REQUEST_ERROR(state, error) {
    Object.assign(state, {
      errors: error,
      loading: false
    })
  },



}


const actions = {

  createPlan(context) {
    return new Promise((resolve, reject) => {
      context.commit('REQUEST_SEND')
      DrainagePlanService.createPlan(context.state.data).then(res => {
        context.commit('REQUEST_SUCCESS')
        resolve(res)
      }).catch(reason => {
        if (reason.status === 422) {
          reject(reason.data.message)
          context.commit('REQUEST_ERROR', reason.data.errors)
        }
      })
    })
  },


  updatePlan(context, id) {
    return new Promise((resolve, reject) => {
      context.commit('REQUEST_SEND')
      DrainagePlanService.updatePlan(id, context.state.data).then(res => {
        context.commit('REQUEST_FINISHED')
        resolve(res)
      }).catch(reason => {
        if (reason.status === 422) {
          reject(reason.data.message)
          context.commit('REQUEST_ERROR', reason.data.errors)
        }
      })
    })
  },

  getPlan(context, id) {
    return new Promise((resolve, reject) => {
      context.commit('REQUEST_SEND')
      DrainagePlanService.getPlanById(id).then(res => {

        context.commit('REQUEST_SUCCESS')
        context.commit('SET_PLAN_DATA', res)
        resolve(res)
      }).catch(reason => {
        if (reason.status === 422) {
          reject(reason.data.message)
          context.commit('REQUEST_ERROR', reason.data.errors)
        }
      })
    })
  },

  deletePlan(context, id, PlanType) {
    return new Promise((resolve, reject) => {
      DrainagePlanService.deletePlan(id, PlanType).then(res => resolve(res))
        .catch(reason => reject(reason))
    })
  },

}




export default {
  namespaced: true,
  state,
  mutations,
  actions
};
